import { FaChevronDown, FaChevronUp, FaSpinner } from 'react-icons/fa';
import { LocationPickerLocation, createActionTaken, ActionTakenType, MilesToMeters, UnitStandard } from "@swivl/swivl-lib";
import { Slide } from "pure-react-carousel";
import React from "react";
import { MessageHandlerInterface } from "../../../../../messages/MessageHandler";
import { ListItemData } from "../../../ListItem";
import { MetersToMiles } from "./MetersToMiles";
import { Config } from '../../../../../Config/Config';



export const SelectedLocationCell: React.FC<{ location: any }> = (props) => {
  const { location } = props;
  const imageSRC = (location.StorePhotoURL) ? location.StorePhotoURL : 'https://swivl-cdn.s3.us-west-1.amazonaws.com/temp-store.png';
  const addressLink = encodeURIComponent(`${location.StoreAddressLine1} ${location.StoreCity}, ${location.StoreState} ${location.StorePostalCode}`);

  return <div className="scc-SelectedLocation">
    <div className="scc-selectedLocationCellWrapper">
      <div className="scc-LocationCell">
        <div className="scc-locationImage">
          <img src={imageSRC} />
        </div>
        <div className="scc-locationText">
          <b>{location.StoreName}</b>
          {location.StoreAddressLine1}
          <br />
          {location.StoreCity}, {location.StoreState} {location.StorePostalCode}
        </div>
      </div>

      <div className="scc-viewMap">
        <a href={'https://maps.google.com/?q=' + addressLink} target="_blank">View Map</a>
      </div>
    </div>

  </div>
}
interface LocationCellProps {
  location: LocationPickerLocation, messageHandler: MessageHandlerInterface, item: ListItemData
}
export const LocationCell: React.FC<LocationCellProps> = (props) => {
  const [startX, setStartX] = React.useState(0);

  const imageSRC = (props.location.imageURL) ? props.location.imageURL : 'https://swivl-cdn.s3.us-west-1.amazonaws.com/temp-store.png';

  const mouseDown = (e: React.MouseEvent<HTMLDivElement>) => {
    setStartX(e.clientX)
  }
  const locationSelected = (e: React.MouseEvent<HTMLDivElement>) => {
    if (!Config.canPressButtons) {
      return;
    }
    if (Math.abs(e.clientX - startX) > 5) { // This checks to make sure we weren't dragging.
      return;
    }



    const messageId = props.item.message.id;
    const actionTaken = createActionTaken(ActionTakenType.Selected, props.item.id, props.location.data)

    props.messageHandler.actionTaken(messageId, actionTaken);
    // this.setState({selectTwo:true});

  }
  return <div
    className="scc-LocationCell swivl-primaryBackgroundHover swivl-primaryTextHover"
    onMouseDown={mouseDown}
    onMouseUp={locationSelected}
  >
    <div className="scc-locationImage">
      <img src={imageSRC} />
    </div>
    <div className="scc-locationText swivl-primaryBackgroundHover">
      <b>{props.location.name}</b>
      {props.location.address}
    </div>
  </div>
}

interface SearchCellProps {
  currentZip: string,
  searchNewZip: (newZip: string) => void,
  searchRadiusInMeters: number,
  messageHandler: MessageHandlerInterface,
  item: ListItemData,
  setShouldFocusOnControl(control: string): void,
  shouldFocusOnControl?: string
  distanceUnit?: UnitStandard

}
export const SearchCell: React.FC<SearchCellProps> = (props) => {
  const [zip, setZip] = React.useState(props.currentZip)
  const [searchRadiusInMeters, setSearchRadiusInMeters] = React.useState(props.searchRadiusInMeters)
  const [showMenu, setShowMenu] = React.useState(false)
  const [isSearching, setIsSearching] = React.useState(false)
  const [hasLoaded, setHasLoaded] = React.useState(false)
  const inputRef = React.useRef<HTMLInputElement>();

  React.useEffect(() => {
    if (props.shouldFocusOnControl === "radius") {
      setShowMenu(true)
      props.setShouldFocusOnControl(undefined)
    }
    if (props.shouldFocusOnControl === "zip" && inputRef.current) {
      inputRef.current.focus();
      props.setShouldFocusOnControl(undefined)
    }

  }, [props.shouldFocusOnControl])


  React.useEffect(() => { setZip(props.currentZip) }, [props.currentZip])
  React.useEffect(() => { setSearchRadiusInMeters(props.searchRadiusInMeters) }, [props.searchRadiusInMeters])
  React.useEffect(() => {
    if (!hasLoaded) {
      setHasLoaded(true)
      return;
    }
    query()
  }, [searchRadiusInMeters])

  const onChange = (e) => { setZip(e.target.value) }
  const toggleMenu = () => { setShowMenu(!showMenu) }

  const query = () => {
    if (!Config.canPressButtons) {
      return;
    }

    setIsSearching(true)
    props.messageHandler.getNewLocations(props.item.message.id, zip, searchRadiusInMeters).then(_ => {
      setIsSearching(false);
    }).catch(e => {
      console.warn("Error getting locations", e)
      setIsSearching(false);
    })
  }

  const radiusOptionClicked = (e) => {
    const title: string = e.target.title;
    if (title.startsWith("Kilometers")) {
      setSearchRadiusInMeters(parseInt(title.split("_")[1]) * 1000)
    } else {

      setSearchRadiusInMeters(MilesToMeters[e.target.title])
    }
    setShowMenu(false);

  }
  const searchClicked = () => { query() }
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      query();
    }
  }




  return <div className="scc-LocationCell scc-SearchLocationCell">
    <span>Search</span>
    {props.distanceUnit === UnitStandard.METRIC ?
      <>
        <div className={showMenu ? "scc-radiusOptions scc-showRadiusMenu" : "scc-radiusOptions"}>

          <div className="scc-radiusOptionsMenu">

            <a title="Kilometers_5" onClick={radiusOptionClicked} className={searchRadiusInMeters === 5000 ? "scc-selectedRadiusOption" : ""}>5</a>
            <a title="Kilometers_10" onClick={radiusOptionClicked} className={searchRadiusInMeters === 10000 ? "scc-selectedRadiusOption" : ""}>10</a>
            <a title="Kilometers_25" onClick={radiusOptionClicked} className={searchRadiusInMeters === 25000 ? "scc-selectedRadiusOption" : ""}>25</a>
            <a title="Kilometers_50" onClick={radiusOptionClicked} className={searchRadiusInMeters === 50000 ? "scc-selectedRadiusOption" : ""}>50</a>
            <a title="Kilometers_100" onClick={radiusOptionClicked} className={searchRadiusInMeters === 100000 ? "scc-selectedRadiusOption" : ""}>100</a>
          </div>
          <div className="scc-selectedRadius" onClick={toggleMenu}>
            <div className="scc-selectedRadiusValue">{searchRadiusInMeters / 1000}</div>
            <div className="scc-selectedRadiusTab swivl-primaryBackgroundHover">{showMenu ? <FaChevronUp /> : <FaChevronDown />}</div>

          </div>

        </div>
        <span>km of zip</span>
      </> : <>
        <div className={showMenu ? "scc-radiusOptions scc-showRadiusMenu" : "scc-radiusOptions"}>

          <div className="scc-radiusOptionsMenu">

            <a title="Miles_5" onClick={radiusOptionClicked} className={searchRadiusInMeters === MilesToMeters.Miles_5 ? "scc-selectedRadiusOption" : ""}>5</a>
            <a title="Miles_10" onClick={radiusOptionClicked} className={searchRadiusInMeters === MilesToMeters.Miles_10 ? "scc-selectedRadiusOption" : ""}>10</a>
            <a title="Miles_25" onClick={radiusOptionClicked} className={searchRadiusInMeters === MilesToMeters.Miles_25 ? "scc-selectedRadiusOption" : ""}>25</a>
            <a title="Miles_50" onClick={radiusOptionClicked} className={searchRadiusInMeters === MilesToMeters.Miles_50 ? "scc-selectedRadiusOption" : ""}>50</a>
            <a title="Miles_100" onClick={radiusOptionClicked} className={searchRadiusInMeters === MilesToMeters.Miles_100 ? "scc-selectedRadiusOption" : ""}>100</a>
          </div>
          <div className="scc-selectedRadius" onClick={toggleMenu}>
            <div className="scc-selectedRadiusValue">{MetersToMiles(searchRadiusInMeters)}</div>
            <div className="scc-selectedRadiusTab swivl-primaryBackgroundHover">{showMenu ? <FaChevronUp /> : <FaChevronDown />}</div>

          </div>

        </div>
        <span>miles of zip</span>
      </>}

    <div className="scc-locationSearchInputAndButton">
      <input value={zip} onChange={onChange} onKeyDown={handleKeyDown} ref={inputRef} />
      <div className="scc-locationSearchButton swivl-primaryButton" onClick={searchClicked}>{isSearching ? <FaSpinner className="spin" /> : "SEARCH"}</div>
    </div>

  </div>
}


interface LocationCardProps {
  index: number
  showSearch?: boolean
  locations: LocationPickerLocation[]
  currentZip: string
  searchRadiusInMeters?: number
  distanceUnit?: UnitStandard
  searchNewZip?: (newZip: string) => void
  messageHandler?: MessageHandlerInterface;
  item?: ListItemData;
  isNoResults?: boolean
  setShouldFocusOnControl(control: string): void
  shouldFocusOnControl?: string
}

export const LocationCard: React.FC<LocationCardProps> = (props) => {
  const { index, locations, showSearch, currentZip, searchNewZip, searchRadiusInMeters, messageHandler, isNoResults, setShouldFocusOnControl, shouldFocusOnControl } = props;
  const searchCell = (showSearch) ? <SearchCell currentZip={currentZip} searchNewZip={searchNewZip} searchRadiusInMeters={searchRadiusInMeters} messageHandler={messageHandler} item={props.item} setShouldFocusOnControl={setShouldFocusOnControl} shouldFocusOnControl={shouldFocusOnControl} distanceUnit={props.distanceUnit} /> : null;
  const cells = (isNoResults) ?
    <div className="scc-noResults">Oops! We didn’t find any locations near you</div>
    : locations.map(item => <LocationCell key={item.id} location={item} messageHandler={messageHandler} item={props.item} />)


  return <Slide index={index} key={"slide_" + index} innerClassName="scc-locationSlide">
    {cells}
    {searchCell}
  </Slide>;
}
